import { ChevronLeft, ChevronRight } from "lucide-react";

const pageList = (page, pages) => {
  const set = new Set([1, pages, page - 1, page, page + 1].filter((p) => p >= 1 && p <= pages));
  const sorted = [...set].sort((a, b) => a - b);
  const out = [];
  sorted.forEach((p, i) => {
    if (i && p - sorted[i - 1] > 1) out.push(`gap-${p}`);
    out.push(p);
  });
  return out;
};

const base = "h-10 min-w-10 px-3 rounded-xl text-sm font-semibold flex items-center justify-center gap-1 transition-colors border";

export const Pagination = ({ page, pages, onChange, prevLabel = "Prev", nextLabel = "Next" }) => {
  if (pages <= 1) return null;
  return (
    <nav className="flex flex-wrap items-center justify-center gap-2 mt-10" data-testid="pagination" aria-label="Pagination">
      <button onClick={() => onChange(page - 1)} disabled={page <= 1} data-testid="pagination-prev"
        className={`${base} bg-white border-slate-200 text-[#12234A] hover:border-[#F5551E] disabled:opacity-40 disabled:pointer-events-none`}>
        <ChevronLeft size={16} /> {prevLabel}
      </button>
      {pageList(page, pages).map((p) => typeof p === "string" ? (
        <span key={p} className="px-1 text-slate-400">…</span>
      ) : (
        <button key={p} onClick={() => onChange(p)} data-testid={`pagination-page-${p}`} aria-current={p === page ? "page" : undefined}
          className={`${base} ${p === page ? "bg-[#12234A] border-[#12234A] text-white" : "bg-white border-slate-200 text-slate-600 hover:border-[#F5551E]"}`}>
          {p}
        </button>
      ))}
      <button onClick={() => onChange(page + 1)} disabled={page >= pages} data-testid="pagination-next"
        className={`${base} bg-white border-slate-200 text-[#12234A] hover:border-[#F5551E] disabled:opacity-40 disabled:pointer-events-none`}>
        {nextLabel} <ChevronRight size={16} />
      </button>
    </nav>
  );
};
